import React from "react";

function HeaderComponent({
  activeSection,
  isMobileNavOpen,
  navLinks,
  onNavigate,
  onToggleMobileNav,
  getSectionHref = (sectionId) => `#${sectionId}`,
}) {
  return (
    <header id="header" className="header d-flex align-items-center fixed-top">
      <div className="container-fluid container-xl position-relative d-flex align-items-center">
        <a
          href={getSectionHref("hero")}
          className="logo d-flex align-items-center me-auto brand-button"
          onClick={(event) => {
            event.preventDefault();
            onNavigate("hero");
          }}
        >
          <img src="/assets/img/logo.jpeg" alt="Operating Software logo" />
          <span className="sitename">Operating Software</span>
        </a>

        <nav id="navmenu" className="navmenu">
          <ul>
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={getSectionHref(link.id)}
                  className={`nav-link-button ${
                    activeSection === link.id ? "active" : ""
                  }`}
                  onClick={(event) => {
                    event.preventDefault();
                    onNavigate(link.id);
                  }}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <button
            type="button"
            className={`mobile-nav-toggle d-xl-none bi ${
              isMobileNavOpen ? "bi-x" : "bi-list"
            }`}
            aria-label={isMobileNavOpen ? "Close navigation" : "Open navigation"}
            onClick={onToggleMobileNav}
          ></button>
        </nav>
      </div>
    </header>
  );
}

export default HeaderComponent;
